<template>
  <div class="promo__header">
    <div class="promo__header__info">
      <div class="logo link link--bg" @click.prevent="moveToFirstSlide"></div>

      <div v-if="isUserNotAuthed" class="promo__header__button link link--text" @click="signIn()">
        <span>{{ $t("promo.header.login") }}</span>
      </div>
      <template v-else>
        <div class="user">
          <div class="promo__header__dropdown">
            <div class="link link--text">
              {{ getProjectUserEmail }}
              <i class="icon icon-arrow-small"></i>
            </div>
            <div class="link link--bg" @click="logOut">
              {{ $t("promo.header.logout") }}
              <i class="icon icon-arrow-big"></i>
            </div>
          </div>
        </div>
      </template>
    </div>

    <div class="promo__header__buttons">
      <div
        v-if="!userHasAccess"
        class="promo__header__button promo__header__button--main link link--bg gtm-button gtm-tariff-screen"
        @click.prevent="showPopup"
      >
        <span>{{ getButtonText }}</span>
      </div>

      <div v-if="showLanguages" class="lang">
        <LangSelector />
      </div>
    </div>
  </div>
</template>
<script>
import ProjectRegisterMixin from "@libs/authorization/ProjectRegisterMixin";
import LangSelector from "../../Common/LanguageSelector";
import { mapGetters } from "vuex";
import env from "@libs/util/environment";

export default {
  name: "PromoPageHeader",
  components: {
    LangSelector,
  },
  mixins: [ProjectRegisterMixin],

  computed: {
    showLanguages() {
      return env.isMyGames();
    },
    ...mapGetters("global", ["getUserData", "userHasAccess"]),
    getProjectUserEmail() {
      return this.$store.state.global.project_user.username;
    },
    getButtonText() {
      if (!this.isUserInProject) return this.$t("starter.login");
      if (this.isUserAuthedNotRegistered) return this.$t("promo.header.reg");

      return this.$t("starter.start_trial");
    },
  },

  methods: {
    moveToFirstSlide() {
      this.$emit("moveToFirstSlide");
    },
    showPopup() {
      this.$emit("showPopup");
    },
  },
};
</script>
